import { baseApiUrl, penPencilApiUrl, penPencilClientId } from '@/utils/common/env.constants';
import { getCookies, getPPClientDetails } from '@/utils/helper/helperFunction';
import { getRandomId } from '@/components/common/video/utils';
import { PP_TOKEN } from '@/utils/common/common.constants';
import { IUserPreferences } from '@/interfaces/common';
import { ClientType } from '../interfaces/api.types';
import { post } from './index';
import { IObjDataDb } from '../interfaces/leadCapture';

class LeadCaptureApi {
  static async getOtp<T>(
    data: {
      username: string;
      countryCode: string;
      organizationId: string;
      firstName?: string;
      lastName?: string;
      captchaToken?: string;
      captchaSiteKey?: string;
    },
    options?: {
      smsType?: string;
      sourceName?: string;
      isCaptchaEnabled?: boolean;
    }
  ) {
    const { smsType = '0', sourceName, isCaptchaEnabled = false } = options || {};

    const endpoint = isCaptchaEnabled
      ? '/v3/users/get-otp-register-secure'
      : '/v3/users/get-otp-register';
    let url = `${endpoint}?smsType=${smsType}`;

    if (sourceName) {
      url += `&sourceName=${sourceName}`;
    }

    const payload = {
      username: data.username,
      countryCode: data.countryCode,
      organizationId: data.organizationId,
      firstName: data.firstName,
      lastName: data.lastName,
      ...(isCaptchaEnabled && {
        captchaToken: data.captchaToken,
        captchaSiteKey: data.captchaSiteKey,
      }),
    };

    return post<T>(url, payload, undefined, penPencilApiUrl, ClientType.PENPENCIL);
  }

  static async resendOtp<T>(
    data: {
      mobile: string;
      organizationId: string;
      captchaToken?: string;
      captchaSiteKey?: string;
    },
    smsType = '0',
    isCaptchaEnabled = false
  ) {
    const endpoint = isCaptchaEnabled ? '/v3/users/resend-otp-secure' : '/v3/users/resend-otp';
    const url = `${endpoint}?smsType=${smsType}`;

    const payload = {
      mobile: data.mobile,
      organizationId: data.organizationId,
      ...(isCaptchaEnabled && {
        captchaToken: data.captchaToken,
        captchaSiteKey: data.captchaSiteKey,
      }),
    };

    return post<T>(url, payload, undefined, penPencilApiUrl, ClientType.PENPENCIL);
  }

  static async sendDataToDatabase(data: IObjDataDb) {
    return post('/v2/ga-events', data, undefined, baseApiUrl);
  }

  static async getPPToken<T>(data: {
    username: string;
    otp: string;
    organizationId: string;
    grant_type: string;
    client_id?: string;
    client_secret?: string;
  }) {
    return post<T>('/v3/oauth/token', data, undefined, penPencilApiUrl, ClientType.PENPENCIL);
  }

  static async verifyPPToken<T>() {
    return post<T>(
      'v3/oauth/verify-token',
      {
        authorization: getCookies(PP_TOKEN),
        client_id: getPPClientDetails()?.clientId || penPencilClientId,
        randomId: getRandomId(),
      },
      undefined,
      penPencilApiUrl,
      ClientType.PENPENCIL
    );
  }

  static async sendEventDataToBackend(userPreferences: IUserPreferences, queryParams: string) {
    const baseUrl = '/lead/onboarding-form';
    const url = queryParams ? `${baseUrl}${queryParams}` : baseUrl;
    const dataToSend = {
      userPreferences: { ...userPreferences },
    };
    return post<IObjDataDb>(url, dataToSend, undefined);
  }
}
export default LeadCaptureApi;
